export default __webpack_public_path__ + "static/media/access-check.1188a9c9.jpg";